// extracted by mini-css-extract-plugin
export default {"title":"Instruction_title__BnFDV","description":"Instruction_description__c0Fz5"};